var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSad = function SvgSad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4961_31606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z",
    fill: "#F7B239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69519 18.3047C1.37845 13.9878 1.03829 7.2005 4.67446 2.49414C4.27167 2.80529 3.88411 3.14546 3.51465 3.51492C-1.17155 8.20112 -1.17155 15.799 3.51465 20.4852C8.20085 25.1713 15.7987 25.1714 20.4849 20.4852C20.8543 20.1157 21.1945 19.7281 21.5057 19.3253C16.7994 22.9616 10.012 22.6214 5.69519 18.3047Z",
    fill: "#E09B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5101 17.249C13.4406 17.249 13.3701 17.2326 13.3042 17.1982C12.9051 16.9893 12.4538 16.8788 11.9989 16.8788C11.5443 16.8788 11.0931 16.9892 10.6942 17.1981C10.4767 17.3121 10.2078 17.2281 10.0938 17.0105C9.97988 16.7929 10.0639 16.524 10.2815 16.4101C10.8073 16.1348 11.4012 15.9893 11.9989 15.9893C12.5968 15.9893 13.1909 16.1348 13.7167 16.4101C13.9344 16.524 14.0184 16.7929 13.9045 17.0105C13.8251 17.1622 13.6703 17.249 13.5101 17.249Z",
    fill: "#E09B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0551 14.1582C10.2213 14.1582 8.49723 14.8723 7.2006 16.169C7.02688 16.3427 7.02688 16.6243 7.2006 16.798C7.37436 16.9717 7.65593 16.9717 7.82965 16.798C8.95824 15.6693 10.4589 15.0477 12.0551 15.0477C13.6513 15.0477 15.152 15.6693 16.2806 16.798C16.3675 16.8848 16.4813 16.9283 16.5951 16.9283C16.7089 16.9283 16.8228 16.8849 16.9096 16.798C17.0834 16.6243 17.0834 16.3427 16.9096 16.169C15.6129 14.8723 13.8888 14.1582 12.0551 14.1582Z",
    fill: "#223137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42283 6.19381C7.42283 5.94819 7.22375 5.74902 6.97804 5.74902C6.73232 5.74902 6.53325 5.94815 6.53325 6.19381C6.53325 7.49935 5.47113 8.56157 4.16549 8.56157C3.91978 8.56157 3.7207 8.76069 3.7207 9.00636C3.7207 9.25198 3.91978 9.45115 4.16549 9.45115C5.96162 9.45105 7.42283 7.98989 7.42283 6.19381Z",
    fill: "#223137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 8.56157C18.5279 8.56157 17.4657 7.49945 17.4657 6.19381C17.4657 5.94819 17.2667 5.74902 17.021 5.74902C16.7752 5.74902 16.5762 5.94815 16.5762 6.19381C16.5762 7.98989 18.0374 9.4511 19.8335 9.4511C20.0792 9.4511 20.2782 9.25198 20.2782 9.00631C20.2783 8.76074 20.0792 8.56157 19.8335 8.56157Z",
    fill: "#223137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33224 10.7345C8.33224 9.82709 7.59402 9.08887 6.68663 9.08887C5.77924 9.08887 5.04102 9.82709 5.04102 10.7345C5.04102 11.6419 5.77924 12.3801 6.68663 12.3801C7.59402 12.3801 8.33224 11.6419 8.33224 10.7345Z",
    fill: "#223137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3116 9.08887C16.4042 9.08887 15.666 9.82709 15.666 10.7345C15.666 11.6419 16.4042 12.3801 17.3116 12.3801C18.219 12.3801 18.9572 11.6419 18.9572 10.7345C18.9572 9.82709 18.219 9.08887 17.3116 9.08887Z",
    fill: "#223137"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4961_31606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sad.e320862a.svg";
export { ForwardRef as ReactComponent };